import React from "react";
import classes from "./Info.module.scss";
import { useTranslation } from "react-i18next";

export interface Topic {
    title: string;
    list: string[];
}

interface FeatureBasicList{
    emoji: string;
    text: string;
}

interface FeatureExtendedList{
    emoji: string;
    title: string;
    ul: string[]
}

export interface Feature {
    title?: string ;
    list?: FeatureBasicList[];
    extendedList?: FeatureExtendedList[];
}

export interface Results{
    title: string;
    text?: string;
    ul: string[];
}

interface InfoProps {
    title: string;
    titleMessage?: string;
    topics: Topic[];
    features: Feature;
    featuresText?: string;
    rightBlock: RightBlock
    results?: Results;
}

interface RightBlock {
    platforms: string[],
    services: string[],
    audience: string[],
    field: string[]
}


const Info: React.FC<InfoProps> = ({
   title,
   titleMessage,
   topics,
   features,
   featuresText,
    results,
    rightBlock
                                   }) => {
    const { t } = useTranslation();

    return (
        <section className={`${classes.container} section--white`}>
            <div className={classes.left}>
                <h2 className={classes.title}>{t(title)}</h2>

                {titleMessage && (
                    <p className={classes.subtitle}>{t(titleMessage)}</p>
                )}

                <div className={classes.topics}>
                    {topics.map((topic, index) => (
                        <div key={index} className={classes.block}>
                            <h3 className={classes.topicTitle}>{topic.title}</h3>
                            <ul>
                                {topic.list.map((item, i) => (
                                    <li key={i}>{t(item)}</li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className={classes.features}>
                    {!features.title && <h3 className={classes.topicTitle}>{featuresText}</h3>}
                    {!!features.title && <p className={classes.customTitle}>{features.title}</p>}

                    {!!features.list && <div className={classes.blocks}>
                        {features.list.map((feature, index) => (
                            <div key={index} className={classes.block}>
                                <span className={classes.emoji}>{feature.emoji}</span>
                                <span className={classes.text}>{feature.text}</span>
                            </div>
                        ))}
                    </div>}
                    {!!features.extendedList && <div className={classes.blocks}>
                        {features.extendedList.map((feature, index) => (
                            <div key={index} className={classes.block}>
                                <span className={classes.emoji}>{feature.emoji}</span>
                                <span className={classes.title}>{feature.title}</span>
                                {feature.ul.length === 1 && <span className={classes.text}>{feature.ul[0]}</span>}
                                {feature.ul.length > 1 && <ul>
                                    {feature.ul.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                </ul>}
                            </div>
                        ))}
                    </div>}
                </div>

                {results && <div className={`${classes.results} ${classes.block}`}>
                    <h3>{results.title}</h3>
                    {!!results.text && <p className={classes.paragraph}>{results.text}</p>}
                    <ul>
                        {results.ul.map((item, i) => (
                            <li key={i}>{item}</li>
                        ))}
                    </ul>
                </div>}
            </div>

            <div className={classes.right}>
                <div className={classes.container}>
                    <div className={classes.row}>
                        <h6>{t('info.platforms')}</h6>
                        <div className={classes.blocks}>
                            {rightBlock.platforms.map((platform, index) => (
                                <div className={classes.block} key={platform}>{platform}</div>
                            ))}
                        </div>
                    </div>
                    <div className={classes.row}>
                        <h6>{t('info.services')}</h6>
                        <div className={classes.blocks}>
                            {rightBlock.services.map((platform, index) => (
                                <div className={classes.block} key={platform}>{platform}</div>
                            ))}
                        </div>
                    </div>
                    <div className={classes.row}>
                        <h6>{t('info.audience')}</h6>
                        <div className={classes.blocks}>
                            {rightBlock.audience.map((platform, index) => (
                                <div className={classes.block} key={platform}>{platform}</div>
                            ))}
                        </div>
                    </div>
                    <div className={classes.row}>
                        <h6>{t('info.applicationArea')}</h6>
                        <div className={classes.blocks}>
                            {rightBlock.field.map((platform, index) => (
                                <div className={classes.block} key={platform}>{platform}</div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Info;